// services/formService.ts

interface FormPayload {
  [key: string]: any;
}

/**
 * Sends form data to our own backend API endpoint, which then securely handles sending the email via Resend.
 * This is the correct, secure way to handle form submissions and protect API keys.
 * @param formName - The name of the form being submitted (e.g., 'contact', 'booking').
 * @param data - The form data object.
 * @returns A promise that resolves to an object indicating success or failure.
 */
export const sendForm = async (formName: string, data: FormPayload): Promise<{ success: boolean; error?: string }> => {
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ formName, data }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: `Server responded with status ${response.status}` }));
      throw new Error(errorData.message || 'An error occurred during form submission. Please try again.');
    }

    return { success: true };

  } catch (error: any) {
    console.error(`[Form Service] Error submitting '${formName}' form:`, error);
    return { success: false, error: error.message || 'An unknown error occurred.' };
  }
};
